import axios from 'axios'
import { FOOD_STORAGE_KEYS, getFoodStorageItem, setFoodStorageItem } from '../utils/embeddedStorage'
import { embeddedShellSsoRelaunch } from '../utils/embeddedShellNav'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/food-api',
  timeout: 30000,
  headers: {
    'ngrok-skip-browser-warning': 'true',
  },
})

// Request interceptor - attach token + timezone; FormData sin Content-Type fijo
api.interceptors.request.use((config) => {
  const token = getFoodStorageItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  // Send user's local timezone automatically (e.g. "America/Bogota")
  config.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone

  // Multipart: el browser debe poner boundary. Un Content-Type: application/json
  // (o multipart sin boundary) hace que Multer ignore las fotos → medidas OK, fotos null.
  const isForm =
    typeof FormData !== 'undefined'
    && config.data
    && typeof config.data === 'object'
    && config.data instanceof FormData
  if (isForm) {
    const h: any = config.headers
    if (h?.delete) {
      h.delete('Content-Type')
      h.delete('content-type')
    } else if (h) {
      delete h['Content-Type']
      delete h['content-type']
      if (h.common) {
        delete h.common['Content-Type']
        delete h.common['content-type']
      }
    }
  } else if (!config.headers['Content-Type'] && !config.headers['content-type']) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})

// Response interceptor - handle 401
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const isAuthEndpoint = err.config?.url?.includes('/auth/login') ||
                           err.config?.url?.includes('/auth/register') ||
                           err.config?.url?.includes('/auth/request-renewal')
    if (err.response?.status === 401 && !isAuthEndpoint) {
      setFoodStorageItem('token', null)
      setFoodStorageItem('user', null)
      setFoodStorageItem('subscription', null)
      const embedded = import.meta.env.VITE_FOOD_EMBEDDED === 'true'
        || (typeof localStorage !== 'undefined' && localStorage.getItem('d28d_shell') === 'true')
      if (embedded) {
        embeddedShellSsoRelaunch()
      } else {
        window.location.href = '/login'
      }
    }
    return Promise.reject(err)
  }
)

export { api }
export default api
